/**
 *
 * @param seconds the number of seconds to convert, e.g. 21.82
 * @returns the srt timecode string, e.g. 00:00:21,820
 */
export const secondsToSrtTime = (seconds: number): string => miliSecondsToSrtTime(seconds * 1000);

/**
 *
 * @param miliseconds the number of miliseconds to convert, e.g. 13040
 * @returns the srt timecode string, e.g. 00:00:13,040
 */
export const miliSecondsToSrtTime = (miliseconds: number): string => {
	const measures = [3600000, 60000, 1000];
	const time = [];

	measures.forEach(m => {
		let res = (miliseconds / m >> 0).toString();

		if (res.length < 2) {
			res = '0' + res;
		}
		miliseconds %= m;
		time.push(res);
	});

	let ms = miliseconds.toFixed().toString();
	if (ms.length < 3) {
		for (let i = 0; i <= 3 - ms.length; i++) {
			ms = '0' + ms;
		};
	}

	return time.join(':') + ',' + ms;
};
